import { render, staticRenderFns } from "./reviewUnPass.vue?vue&type=template&id=7ced6d4c"
import script from "./reviewUnPass.vue?vue&type=script&lang=js"
export * from "./reviewUnPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports